import React, { createContext, useContext, useEffect, useState } from "react";
import { handleError, HttpCALLWithToken } from "./useHttps";
import helper from "../common/helper";
import appContext from "./appContext";
import { GetProfileData } from "../network/networkSettings";
import { GET, ISLOADING, SETUSERPROFILE } from "./constants";

const UserContext = createContext({});

export const UserProvider = ({ children }) => {
  const appContextValue = useContext(appContext); // Use appContext value here
  const token = helper.SecureStorageFunc("userToken", "get", "");
  const [user, setUser] = useState(null);
  const [topCards, setTopCards] = useState([{}]);
  const [dashboardDropdownData, setDashboardDropdownData] = useState([{}]);
  const getProfileData = () => {
    HttpCALLWithToken(`${GetProfileData}`, GET, token, {})
      .then((res) => {
        if (res.data.data) {
          appContextValue.dispatch({
            type: ISLOADING,
            payload: false,
          });
          setUser(res.data.data);
        }
        if (res.data.data.image) {
          appContextValue.dispatch({
            type: SETUSERPROFILE,
            payload: res.data.data.image,
          });
          setUser(res.data.data);
        }
      })
      .catch((err) => {
        appContextValue.dispatch({
          type: ISLOADING,
          payload: false,
        });
        handleError(err);
      });
  };
  
  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        getProfileData,
        topCards, 
        setTopCards,
        dashboardDropdownData,
        setDashboardDropdownData
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
